import React, { useEffect, useState, useMemo } from "react";
import useApi from "../CustomHooks/useApi";
import { useNavigate } from "react-router-dom";
import { viewsAPI } from "../../api/apiClient";
import LoadingOverlay from "../../LoadingOverlay";
import "../../css/Views/ViewsDashboard.css";
import { ViewIcon } from "../../utils/ViewIcons";

const ViewsDashboard = () => {
  const [groups, setGroups] = useState([]); 
  const { callApi, isLoading } = useApi();
  const navigate = useNavigate();

  useEffect(() => {
    callApi(
      () => viewsAPI.getAvailableViews(),
    (data) => {
      const arr = Array.isArray(data) ? data.slice() : [];
      setGroups(arr);
    }
    );
  }, []);


  const handleViewClick = (viewGuid) => navigate(`/views/${viewGuid}`);

  const normalized = useMemo(() => {
    return (groups ?? [])
      .map(g => ({
        groupName: g.viewGroup ?? "Pozostałe",
        items: (g.views ?? []).slice().sort((a,b) => (a.name||"").localeCompare(b.name||"", "pl"))
      }))
      .sort((a,b) => a.groupName.localeCompare(b.groupName, "pl"));
  }, [groups]);

  return (
    <div className="views-dashboard-container">
      {isLoading && <LoadingOverlay text="Ładowanie widoków..." />}

      <div className="views-header">Widoki specjalne</div>

      {!isLoading && normalized.length === 0 && (
        <div className="empty-message">Brak dostępnych widoków.</div>
      )}

      {normalized.map(({ groupName, items }) => (
        <section className="views-group" key={groupName}>
          <h3 className="views-group-title">{groupName}:</h3>

          <div className="views-list">
          {items.map((view) => (
            <div
              className="view-card"
              key={view.guid}
              onClick={() => handleViewClick(view.guid)}
            >
              <div className="view-icon-centered">
                <ViewIcon name={view.faIcon} className="view-icon" />
              </div>
              <div className="view-name-centered">{view.name}</div>
            </div>
          ))}

          </div>
        </section>
      ))}
    </div>
  );
};

export default ViewsDashboard;
